// extracted by mini-css-extract-plugin
export default {"Map":"Map_Map__3E2cD","Map__left":"Map_Map__left__2h3Lk","Map__right":"Map_Map__right__7pPEc","Map__order":"Map_Map__order__SfY2j"};